// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"zg_a bhv_px bhv_a bhv_w bhv_cw bhv_sb","PasswordResetEmail__title":"zg_b bhv_uj bhv_qk bhv_tu","PasswordResetEmail__subtitle":"zg_c bhv_tu"};